import { render } from "./certificate.vue?vue&type=template&id=0423d5b4&scoped=true&ts=true"
import script from "./certificate.vue?vue&type=script&lang=ts"
export * from "./certificate.vue?vue&type=script&lang=ts"

import "./certificate.vue?vue&type=style&index=0&id=0423d5b4&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0423d5b4"]])

export default __exports__